import React, { useEffect, useState } from 'react';
import { UserPlus } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { trackEvent } from '../lib/analytics';

export const MobileCTABar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const contact = document.getElementById('contact');
      const nearContact = contact && contact.getBoundingClientRect().top < window.innerHeight * 0.5;
      setVisible(window.scrollY > 400 && !nearContact);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      data-testid="mobile-cta-bar"
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="grid grid-cols-2 gap-3 px-4 py-3">
        <button
          data-testid="mobile-cta-asociate"
          onClick={scrollToContact}
          className="flex items-center justify-center gap-2 h-12 rounded-xl bg-blue-600 text-white font-semibold text-sm active:bg-blue-700"
        >
          <UserPlus className="w-5 h-5" />
          Asociate ahora
        </button>
        <a
          data-testid="mobile-cta-whatsapp"
          href="https://wa.me/5491130295481"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('click_whatsapp', { location: 'barra_mobile' })}
          className="flex items-center justify-center gap-2 h-12 rounded-xl border-2 border-blue-600 text-blue-600 font-semibold text-sm active:bg-blue-50"
        >
          <WhatsAppIcon className="w-5 h-5" />
          WhatsApp
        </a>
      </div>
    </div>
  );
};
